export const getMaybeCombinedError = (errors: (Error | undefined)[]): Error | undefined => {
	const messages = errors.flatMap((error) => (error ? [error.message] : []));
	return messages.length === 0 ? undefined : Error(messages.join(', '));
};
